import { useQuery } from '@tanstack/react-query';
import { api, unwrap } from './client';
import type { components } from './schema';

export type AuditEvent = components['schemas']['AuditEvent'];

export interface AuditFilters {
  type?: string;
  subject_type?: string;
  subject_id?: string;
  project?: string;
  since?: string;
  /** Staff filters added with the ops screens: the actor, their organization, a subject id. */
  actor?: string;
  organization?: string;
  q?: string;
}

/** Staff-only global audit read (milestone 1 endpoint); clients use the per-project route. */
export async function listAudit(f: AuditFilters): Promise<AuditEvent[]> {
  return unwrap(await api.GET('/api/audit', { params: { query: f } })).results;
}

export function useAuditEvents(f: AuditFilters, enabled = true) {
  return useQuery({ queryKey: ['audit', f], queryFn: () => listAudit(f), enabled });
}
